import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

export function IcnArrowRight(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="arrow-right">
      <line x1="3" y1="8" x2="13" y2="8" />
      <path d="M9.5 4.5L13 8l-3.5 3.5" />
    </Svg>
  );
}
